module.exports = __webpack_public_path__ + "img/box.671fa44a.png";